<script setup lang="ts">
type Props = {
  city?: string;
  country: string;
};

defineProps<Props>();
</script>

<template>
  <span class="flex items-center gap-1.5">
    <UIcon
      name="i-custom-location-pin"
      :size="16"
      mode="svg"
      aria-hidden="true"
      class="text-gray-700 dark:text-primary-100 self-center lg:text-sm"
    />
    <span class="text-base text-gray-700 dark:text-primary-100">
      <template v-if="city">{{ city }}, </template>{{ country }}
    </span>
  </span>
</template>
